(function () {
  if (window.__cartQuantityStepperBound === true) return;
  window.__cartQuantityStepperBound = true;

  // CRO 19.07.26: el tema trae un handler legacy (jQuery, compilado dentro
  // de assets/js-main-cart.js) que escucha 'keyup' en estos mismos inputs,
  // hace su propio debounce (1s) y su propio POST a /cart/update.js -- en
  // paralelo al flujo de este archivo. Las dos peticiones competian entre
  // si. Se intercepta 'keyup' en fase de captura (que siempre corre antes
  // que un listener normal en el mismo elemento) y se detiene su
  // propagacion, dejando un unico flujo de actualizacion: el de este
  // archivo.
  document.addEventListener(
    'keyup',
    function (event) {
      if (event.target != null && event.target.classList && event.target.classList.contains('js-cart-item-input')) {
        event.stopImmediatePropagation();
      }
    },
    true
  );

  var syncTimer = null;

  // CRO 19.07.26 (fix critico): cada linea del carrito tiene DOS inputs de
  // cantidad en el DOM al mismo tiempo (uno para mobile, otro para
  // desktop -- mismo data-id, solo uno visible segun el ancho de
  // pantalla vía CSS). Si solo se actualiza el input que el usuario toco,
  // el otro se queda con el valor viejo; buildUpdates() lee AMBOS al armar
  // la peticion, y si toma el valor viejo, el servidor "revierte" la
  // cantidad que el usuario acababa de cambiar. Esta funcion sincroniza
  // los dos inputs de la misma linea (mismo .cart-item) de inmediato.
  var syncSiblingInputs = function (changedInput, value) {
    var row = changedInput.closest('.cart-item');
    if (row == null) return;
    row.querySelectorAll('.js-cart-item-input').forEach(function (el) {
      if (el !== changedInput && el.value !== String(value)) el.value = value;
    });
  };

  var buildUpdates = function () {
    var updates = {};
    document.querySelectorAll('.cart-item .js-cart-item-input').forEach(function (input) {
      var variantId = input.getAttribute('data-id');
      if (!variantId) return;
      var qty = parseInt(input.value, 10);
      // CRO 20.07.26: 0 ahora SI es valido -- equivale a eliminar el
      // producto (antes se forzaba de regreso a 1, por lo que bajar de 1
      // con el boton "-" no hacia nada). Solo se sanea si es NaN o
      // negativo.
      if (isNaN(qty) || qty < 0) qty = 0;
      updates[variantId] = qty;
    });
    return updates;
  };

  var applyQuantitiesToInputs = function (cart) {
    if (!Array.isArray(cart.items)) return;
    cart.items.forEach(function (item) {
      document.querySelectorAll('.cart-item [data-id="' + item.variant_id + '"]').forEach(function (input) {
        if (parseInt(input.value, 10) !== item.quantity) input.value = item.quantity;
      });
    });
  };

  var scheduleSync = function () {
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(runSync, 400);
  };

  // CRO 19.07.26: loader sutil -- SOLO se marca como "sincronizando" la(s)
  // fila(s) que realmente cambiaron desde el ultimo envio (no todo el
  // carrito). Se acumulan en un Set hasta que se dispara la peticion, y se
  // les quita la clase solo a esas mismas filas cuando la respuesta llega.
  var dirtyRows = new Set();

  var markRowDirty = function (input) {
    var row = input.closest('.cart-item');
    if (row != null) dirtyRows.add(row);
  };

  var setRowsSyncing = function (rows, isSyncing) {
    rows.forEach(function (row) {
      row.classList.toggle('is-syncing-quantity', isSyncing);
    });
  };

  // CRO 21.07.26: Alejandro confirmo el sintoma -- al editar cantidades
  // SIN recargar la pagina, el envio/descuento de mayoreo mostrado a
  // veces sale mal (ej. envio contado de mas), pero al recargar la
  // pagina el numero ya sale correcto. La causa: el propio JSON que
  // regresa /cart/update.js puede traer el descuento automatico de
  // mayoreo (total_discount / total_price) calculado con un "tick" de
  // retraso -- Shopify a veces no alcanza a re-evaluar los descuentos
  // automaticos a tiempo dentro de la MISMA respuesta de escritura,
  // sobre todo justo cuando una cantidad cruza el umbral de un tier.
  // Una recarga de pagina hace un GET normal del carrito, que si trae
  // el descuento ya recalculado -- por eso "al recargar ya funciona".
  //
  // Fix: despues de que /cart/update.js responde, se hace un GET extra
  // e inmediato a /cart.js (el mismo endpoint de lectura que usa una
  // recarga) y se usa ESE resultado para pintar los totales, en vez de
  // confiar en el cart que regreso la escritura. Cuesta una peticion
  // extra, pero es exactamente lo que reproduce "recargar la pagina".
  var fetchFreshCart = function () {
    return window.fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  };

  var runSync = function () {
    syncTimer = null;

    // QA 26.07.26 (fix critico -- filas se quedaban con datos viejos):
    // se reserva un numero de secuencia AL INICIO, antes incluso de
    // mandar la peticion. Si mientras esta escritura esta en vuelo el
    // usuario dispara otro cambio (u otra sync, como la del boton
    // eliminar o la del cargar-pagina en js-cart-totals-sync.js), ese
    // otro tomara un numero mas alto -- y cuando ESTA respuesta llegue
    // (aunque llegue despues), __cartSyncApplyIfCurrent la descarta en
    // vez de pisar el DOM con datos obsoletos. Ver el comentario largo en
    // js-cart-totals-sync.js.
    var syncId = window.__cartSyncBumpSeq();

    var updates = buildUpdates();
    var url = (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js';

    var rowsForThisRequest = Array.from(dirtyRows);
    dirtyRows = new Set();
    setRowsSyncing(rowsForThisRequest, true);

    window
      .fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        // Cantidades e items removidos se aplican de inmediato con la
        // respuesta de la escritura (eso si siempre viene correcto).
        applyQuantitiesToInputs(cart);

        var $bubble = document.querySelector('.cart-count-bubble span');
        if ($bubble != null) $bubble.textContent = String(cart.item_count);

        if (cart.item_count === 0) {
          window.location.reload();
          return null;
        }

        // Los totales (envio, descuento, total estimado) se pintan con
        // un GET de refresco a /cart.js -- ver comentario CRO 21.07.26
        // arriba. Se aplica solo si nadie reservo un numero mas nuevo
        // mientras esperabamos (ver QA 26.07.26 arriba).
        return fetchFreshCart()
          .then(function (freshCart) {
            window.__cartSyncApplyIfCurrent(syncId, freshCart);
          })
          .catch(function () {
            // Si el refresco falla por lo que sea, no dejamos los
            // totales sin pintar: se usa el cart de la escritura como
            // respaldo (mismo comportamiento que antes de este fix).
            window.__cartSyncApplyIfCurrent(syncId, cart);
          });
      })
      .catch(function () {})
      .finally(function () {
        setRowsSyncing(rowsForThisRequest, false);
      });
  };

  // Tipeo directo en el input (teclado).
  document.addEventListener('input', function (event) {
    var target = event.target;
    if (target == null || target.classList == null || !target.classList.contains('js-cart-item-input')) return;
    syncSiblingInputs(target, target.value);
    markRowDirty(target);
    scheduleSync();
  });

  // Botones +/- del stepper.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target == null || target.closest == null) return;

    var button = target.closest('.cart-items .qom-stepper-btn');
    if (button == null) return;

    var wrapper = button.closest('.qom-stepper');
    if (wrapper == null) return;
    var input = wrapper.querySelector('.js-cart-item-input');
    if (input == null) return;

    var action = button.getAttribute('data-action');
    var current = parseInt(input.value, 10);
    if (isNaN(current) || current < 0) current = 0;

    var next = current;
    if (action === 'plus') {
      next = current + 1;
    } else if (action === 'minus' && current > 0) {
      // CRO 20.07.26: ya se permite bajar hasta 0 (elimina el producto),
      // antes se detenia en 1 y el boton "-" no hacia nada.
      next = current - 1;
    }
    if (next === current) return;

    input.value = next;
    syncSiblingInputs(input, next);
    markRowDirty(input);
    scheduleSync();
  });
})();
